<template>
  <div>
    <ShippingHeaderAdd @back="back" :title="id ? $t('atualizar-transportadora') : $t('adicionar-novo-transportadora')" />
    <ShippingAddForm />
  </div>
</template>
<script>
import { UserService } from "@/services/users/user.services";
import ShippingAddForm from './components/ShippingAddForm';
import ShippingHeaderAdd from "./components/ShippingHeaderAdd.vue";

export default {
  name: "ShippingAdd",
  components: {
    ShippingHeaderAdd,
    ShippingAddForm,
  },
  data() {
    return {
      id: "",
    }
  },
  methods: {
    back() {
      this.$router.push({ name: "shipping" });
    },
    mounted() {
      const vm = this;
      if (this.$route.params.id) {
        this.id = this.$route.params.id;
      }
    },
  }
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}

.options {
  font-size: 16px;
}
</style>
